import isNilValue from 'utils/predicates/any/isNilValue.util';

const fromSalonVatToDto = (item) => ({
  is_vat_registered: isNilValue(item?.isVatRegistered) ? void 1 : !!item?.isVatRegistered,
  vat_number: item?.vatNumber ?? void 1,
});

export default fromSalonVatToDto;
